'use strict';

var App = require('app');
var AppState = require('app_state');

var FullScreen = Marionette.Behavior.extend({
    ui: {
        fullScreenBtn: '#js-toggle-fullscreen',
    },

    events: {
        'click @ui.fullScreenBtn': 'toggleFullscreen',
    },

    initialize: function () {
        $('body').on('keydown', '', $.proxy(this.leaveFullscreen, this));
        AppState.isFullScreen = false;
    },

    onBeforeDestroy: function () {
        this.leaveFullscreen();
        $('body').off('keydown', this.leaveFullscreen);
    },

    toggleFullscreen: function (e) {
        if (e) {
            e.preventDefault();
        }

        AppState.isFullScreen = !AppState.isFullScreen;
        if (AppState.isFullScreen) {
            $('body')[0].style.overflowY = 'hidden';
            $('.content-page').addClass('full-screen');
            if (this.getOption('on')) {
                this.getOption('on')();
            }

            if (this.options.onEnterFullscreen) {
                this.options.onEnterFullscreen.call(this.view);
            }
        } else {
            $('body')[0].style.overflowY = 'scroll';
            $('.content-page').removeClass('full-screen');
            if (this.getOption('off')) {
                this.getOption('off')();
            }
            if (this.options.onLeaveFullscreen) {
                this.options.onLeaveFullscreen.call(this.view);
            }
        }
        App.forceResize();
        if (this.options.onAfterToggle) {
            this.options.onAfterToggle.call(this.view, e, AppState.isFullScreen);
        }
    },

    leaveFullscreen: function (e) {
        if (e && e.keyCode != 27) {
            return;
        }
        if (AppState.isFullScreen === true) {
            this.toggleFullscreen(e);
        }
    },
});

module.exports = FullScreen;
